<template>
  <div class="question-unanswered-component-container">
    <topic
      v-if="embeddedTopic"
      :topic="embeddedTopic"
      :send-analytics="true"
      :show-title="false"
      :source="topicSource"
    />
    <div
      class="flashcard-content"
      data-test="flashcard-question-text"
      v-html="flashcardQuestion"
    />
    <old-asset-associations-list
      v-if="assetAssociationButtons.length > 0"
      :asset="flashcard"
      context="question"
      data-test="asset-associations-list"
      @flashcard-aa-clicked="$emit('flashcard-aa-clicked', $event)"
    />
  </div>
</template>

<script>
import OldAssetAssociationsList from '@components/assetAssociations/oldList';
import Topic from '@components/topics/topic';

export default {
  name: 'QuestionUnanswered',
  components: { OldAssetAssociationsList, Topic },
  props: {
    category: {
      type: Object,
      default: () => {},
    },
    casesEnabled: {
      type: Boolean,
      default: false,
    },
    flashcard: {
      type: Object,
    },
  },
  emits: ['flashcard-aa-clicked'],
  computed: {
    assetAssociationButtons() {
      return (this.flashcard.assetAssociations || []).filter(aa => aa.displayType !== 'embed_before');
    },
    embeddedTopic() {
      if (this.flashcard.assetAssociations) {
        const topicAA = this.flashcard.assetAssociations.find(aa => aa.assetBType === 'Topic' && aa.displayType === 'embed_before');
        if (topicAA) {
          return this.$store.getters['topics/topics'][topicAA.assetBId];
        }
      }
    },
    flashcardQuestion() {
      let text = '';
      const flashcardTypes = ['Highlight', 'Cloze / Dropdown'];
      if( !flashcardTypes.includes(this.flashcard.type) ) {
        text = this.flashcard.question;
      }
      return text;
    },
    topicSource() {
      return {
        sourceId: this.flashcard?.id,
        sourceType: 'Flashcard',
        sourceCategoryId: this.category?.id,
        sourceCategory: this.category?.name,
      };
    },
    isClozeDropdown() {
      return this.flashcard?.type == 'Cloze / Dropdown';
    },
  },
};
</script>

<style lang="scss" scoped>
.question-unanswered-component-container {
  :deep(.topic-component-container) {
    .top-content {
      padding: rem-calc(16) 0;

      .content {
        margin: 0;
      }
    }
  }

  .flashcard-content {
    color: #000000;
    line-height: rem-calc(24);
    padding: 0 0 rem-calc(16) 0;

    :deep(img) {
      display: block;
      margin: auto;
      max-width: 100%;
      width: auto;
    }
  }
}
</style>
